import EventEmitter from 'eventemitter3'
import NetworkManager from '../lib/models/network-manager'
import { AppData, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup'

export abstract class Platform extends EventEmitter {
  protected _pluginVersion: string
  protected _firmwareVersion: string
  protected _deviceId: string
  protected _make: string
  protected _fullModel: string
  protected _ip: string
  protected _ua: string
  protected _appVer: string //used for hibrid apps in samsung.
  protected _ifa: string
  protected _limitAdTracking = '0'
  protected _ifaType: string
  protected isDevice = false
  protected keyMap: any = null
  protected _partnerId: string = ''
  public _shouldShowExitPopup = false
  public networkManager: NetworkManager
  public _siteConfig!: any
  public isVideoSuspended: boolean
  public agePolicy: string
  public skipBookmarkOnDeeplink = false

  constructor() {
    super()
    this._pluginVersion = ''
    this._firmwareVersion = ''
    this._deviceId = ''
    this._make = ''
    this._fullModel = ''
    this._ip = ''
    this._ua = navigator.userAgent
    this._appVer = '' //used for hibrid apps in samsung.
    this._ifa = ''
    this._limitAdTracking = '0'
    this._ifaType = ''
    this._partnerId = '',
    this.networkManager = new NetworkManager()
    this.isVideoSuspended = false
    this.agePolicy = ''
  }

  setKeyMappings(appSettings: any) {
  }

  _setKeys() {
    //empty function to be overwritten buy the deriving class.
  }

  async initialize(): Promise<boolean> {
    return Promise.resolve(true);
  }

  //getter / setter methods.
  getIp() {
    return this._ip
  }

  getCountry() {
    return ''
  }

  getDeviceId() {
    const {appConfig} = AppData as AppSetup
    if (appConfig?.testDeviceId !== '') { //remove this condition "appConfig.consoleDebugLog == true"
      return appConfig?.testDeviceId
    }
    return this._deviceId
  }

  getMake() {
    return this._make
  }

  getFullModel() {
    return this._fullModel
  }

  getPartnerId() {
    return this._partnerId
  }

  getUA() {
    return this._ua
  }

  getIFA() {
    return this._ifa
  }

  getIFAType() {
    return this._ifaType
  }

  getLimitAdTracking() {
    return this._limitAdTracking
  }

  getPluginVersion() {
    return this._pluginVersion
  }

  getFirmwareVersion() {
    return this._firmwareVersion
  }

  getAppVersion() {
    return this._appVer
  }

  getAppStoreId(indexObj: any) {
    if (indexObj) return ''
    return ''
  }

  getUserAgent() {
    return navigator.userAgent
  }

  dispatchEvent(eventType: string, data?: object) {
    this.emit(eventType, data)
  }

  sendMetrics(eventType: string, dataObj: any) {
    return Promise.resolve()
  }

  getAdConfig(options: any) {
    return Promise.resolve(null)
  }

  // Some platforms (Samsung, Vizio) map a legacy siteId to a canonical one so
  // ad app-name/bundle/store macros resolve correctly. Base: identity. This is
  // applied at boot in initialize() and again on a runtime site switch.
  remapSiteId(siteId: string): string {
    return siteId
  }

  // The ad SDK a platform prefers before any runtime narrowing. Base: 'ima';
  // Comcast overrides to 'freewheel'. Used when re-deciding adSdkToUse on a
  // site switch so it can be re-promoted, not only narrowed down to 'ima'.
  getDefaultAdSdk(): string {
    return 'ima'
  }

  _setUpNetworkListener(): void {
    //Generic physical Network connection format. // shoule implement in the derived specific platforms.
    // window.addEventListener('offline', () => {
    //   Logger.printLog('info', 'NetworkManager:', ' device is offline');
    //   this._networkManager.deviceNetworkConnected = false;
    // })
    // window.addEventListener('online', ()=> {
    //   Logger.printLog('info', 'NetworkManager:', 'device is online');
    //   this._networkManager.deviceNetworkConnected = false;
    // })
  }

  /**
   * This method takes returns the url for the options icon
   * can be override but the inheritanec class.
   *
   * @param {(string|undefined)} apiOptionsIcon 
   * @returns {*} 
   */
  getOptionsIconPath(apiOptionsIcon:string|undefined) {
    if(apiOptionsIcon && apiOptionsIcon !== '') {
      return apiOptionsIcon
    }
    return Utils.asset('/images/option_i.png')
  }

  /**
   * This will give the button text for option menu
   *
   * @returns {string} 
   */
  getOptionsText() {
    return 'Press i for Options'
  }

  async getPlatformDeeplinkData() {
    return Promise.resolve('location.search')
  }

  setIFADetails(ifa: { ifa: string, ifa_type: string, lmt: string }) {
    this._ifa = ifa.ifa
    this._ifaType = ifa.ifa_type
    this._limitAdTracking = ifa.lmt
  }

  textToSpeach(textToPlay : string){

  }

  /**
   * return true if the related key of the specific platform is pressed.
   *
   * @param {KeyboardEvent} e 
   * @returns {boolean} 
   */
  isOptionsKey(e: KeyboardEvent):boolean {
    if(e.code == 'KeyI') {
      return true
    }
    return false
  }

  /**
   * To load the platform related scripts
   *
   * @param {*} platformSettings 
   * @returns {string[]} 
   */
  getScript(platformSettings):string[] {
    return [
      'https://code.jquery.com/jquery-3.7.0.min.js',
      platformSettings.path + 'modules/hlsjs/hls.min.js',
      platformSettings.path + 'modules/dashjs/dash.all.min.js',
      platformSettings.path+'modules/freewheel/AdManager-v2.js',
      'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
    ]
  }

  getFonts(genre: string) {
    //if (genre.toLocaleUpperCase() !== "KIDS") {
      return [
        {
          family: "Light",
          url: Utils.asset("fonts/Museo_Sans_300.ttf") as string,
        },
        {
          family: "Regular",
          url: Utils.asset("fonts/Museo_Sans_500.ttf") as string,
        },
        {
          family: "Black",
          url: Utils.asset("fonts/Museo_Sans_900.ttf") as string,
        },
     // ];
    // } else {
    //   return [
        {
          family: "Light-kids",
          url: Utils.asset("fonts/Museo_Sans_Rounded_300.ttf") as string,
        },
        {
          family: "Regular-kids",
          url: Utils.asset("fonts/Museo_Sans_Rounded_500.ttf") as string,
        },
        {
          family: "Black-kids",
          url: Utils.asset("fonts/Museo_Sans_Rounded_900.ttf") as string,
        },
      ];
    //}
  }

  /**
   * getAppOptions returns the Lighining Configuration parameters which can be
   * customized and overridden for different platforms.
   *
   * @param {*} appSettings 
   * @param {*} platformSettings 
   */
  getAppOptions(appSettings: any, platformSettings: any) {
      const canvas = document.createElement('canvas')
      const vw = window.screen.width;   //less safeFrame
      const vh = window.screen.height; //less safeFrame
      //const scalling:any = vh == 1080 ? 1 : ((vh / 1080).toPrecision(7));
      canvas.setAttribute('width','1920')
      canvas.setAttribute('height','1080')
      canvas.setAttribute('style', 'position: absolute;z-index: 2;width: 100vw;height: 100vh;')
      appSettings.stage.canvas = canvas
      const precision=1
      appSettings.stage.w = 1920 
      appSettings.stage.h = 1080
      appSettings.stage.precision = precision
      window.platformSettings = platformSettings as PlatformSettings
  }

  getHlsOptions(): any { 
      return {
        debug: false,
        enableWorker: true,
        maxBufferLength: 10,        // Keeps up to 10s of video in the buffer
        maxMaxBufferLength: 20,     // Maximum buffer length can grow up to 20s
        maxBufferSize: 36 * 1000 * 1000, // Max buffer size: 36MB
        maxBufferHole: 0.1,        // Small buffer hole to prevent rebuffering
        backBufferLength: 5,        // Keep only the last 5 seconds of buffered video
        appendErrorMaxRetry: 3
    }
  }

  //Ad Macros related value mapping functions based on the platform.

  getAppNameMacro(appName: string, siteId?: string): string {
    return appName
  }

  getDeviceLanguage() {
    return 'en';
  }

  getAppStoreUrlMacro(appName: string, site_id: string): string {
    return ''
  }

  getRatingMacro(rating: string): string {
    return rating
  }

  getGenreMacro(genres: string): string {
    return genres
  }

  getAgePolicy(): string {
    return this.agePolicy
  }

  showGridArrowButtons(): boolean {
    return false
  }

  // VegaOS (FireTV) - inert defaults, overridden only by PlatformFireTV
  getSlot(context: string) {
    return ''
  }
  requestApsBid(apsBid: any, key: string, context: string, vodInfo: any): Promise<void> {
    return Promise.resolve()
  }
  waitApsBid(apsBid: any, key: string): Promise<void> {
    return Promise.resolve()
  }
  getDeviceOSVersion() {
    return ''
  }
  updatePlaybackInfo(state: any, position: any) {
  }
}
